import { userCache } from '@/store/userInfo';

export const SHARED_APP_FILTER_KEY = 'selectedAppUuid';
export const APP_SCOPE_CACHE_KEYS = [
  SHARED_APP_FILTER_KEY,
  'authAppUuid',
  'catalogAppUuid',
  'spaceAppUuid',
  'overviewAppUuid',
  'metadataAppUuid',
  'modelAppUuid',
  'tagAppUuid',
  'tokenAppUuid',
  'dictAppUuid',
];

const normalizeKeys = (legacyKeys: string[] = []) =>
  Array.from(new Set([SHARED_APP_FILTER_KEY, ...legacyKeys]));

export const getRememberedAppUuid = (legacyKeys: string[] = []) => {
  const keys = normalizeKeys(legacyKeys);
  for (const key of keys) {
    const value = localStorage.getItem(key);
    if (value) {
      return value;
    }
  }
  return '';
};

export const setRememberedAppUuid = (
  value: string,
  legacyKeys: string[] = [],
) => {
  const keys = normalizeKeys(legacyKeys);
  keys.forEach((key) => {
    if (value) {
      localStorage.setItem(key, value);
      return;
    }
    localStorage.removeItem(key);
  });
};

export const resolveScopedAppUuid = (legacyKeys: string[] = []) => {
  if (userCache.isSuperAdmin === 1) {
    return (
      userCache.permissionAppUuid ||
      userCache.currentAppUuid ||
      getRememberedAppUuid(legacyKeys)
    );
  }
  return userCache.currentAppUuid || '';
};

export const sanitizeRememberedAppScopes = (
  validAppUuids: string[],
  fallbackAppUuid = '',
) => {
  if (typeof window === 'undefined') return;
  const validSet = new Set(validAppUuids.filter(Boolean));
  const keys = Array.from(
    new Set([
      ...APP_SCOPE_CACHE_KEYS,
      ...Object.keys(window.localStorage).filter(
        (key) => key.endsWith('AppUuid') || key === SHARED_APP_FILTER_KEY,
      ),
    ]),
  );

  keys.forEach((key) => {
    const value = window.localStorage.getItem(key) || '';
    if (!value) return;
    if (validSet.has(value)) return;
    if (fallbackAppUuid) {
      window.localStorage.setItem(key, fallbackAppUuid);
      return;
    }
    window.localStorage.removeItem(key);
  });
};
